var REACT_ELEMENT_TYPE;function _jsx(type, props, key, children) {REACT_ELEMENT_TYPE || (REACT_ELEMENT_TYPE = "function" == typeof Symbol && Symbol.for && Symbol.for("react.element") || 60103);var defaultProps = type && type.defaultProps,childrenLength = arguments.length - 3;if (props || 0 === childrenLength || (props = { children: void 0 }), 1 === childrenLength) props.children = children;else if (childrenLength > 1) {for (var childArray = new Array(childrenLength), i = 0; i < childrenLength; i++) childArray[i] = arguments[i + 3];props.children = childArray;}if (props && defaultProps) for (var propName in defaultProps) void 0 === props[propName] && (props[propName] = defaultProps[propName]);else props || (props = defaultProps || {});return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: void 0 === key ? null : "" + key, ref: null, props: props, _owner: null };}import React, { useState } from 'react';
import { ToggleButton } from "../../UI";









export const ToggleChildren = ({
  children,
  toggled = false,
  onToggleOff = () => {},
  onToggleOn = () => {}
}) => {
  const [isToggled, setToggled] = useState(toggled);

  const handleClick = () => {
    if (isToggled) {
      onToggleOff();
    } else {
      onToggleOn();
    }
    setToggled(!isToggled);
  };

  return /*#__PURE__*/(
    React.createElement(React.Fragment, null, /*#__PURE__*/
    _jsx("div", { className: "toggle-children-button" }, void 0, /*#__PURE__*/
    _jsx(ToggleButton, { onClick: handleClick, checked: isToggled })), /*#__PURE__*/

    _jsx("div", { className: "toggle-children-children", style: { display: isToggled ? 'block' : 'none' } }, void 0,
    children)));



};